'use strict';

var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates an inspector read only field
 *
 * @class
 */

class InspectorReadOnly extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {
				'title': '',
				'value': '',
				'tooltip': ''
			}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
			<div class="editor__inspector__item">
				<div class="editor__inspector__item__label" title="<%- tooltip %>"><%- title %></div>
				<input class="editor__inspector__item__textinput editor__inspector__item__textinput--readonly js-inspector__textinput__value" type="text" value="<%- value %>" readonly>
			</div>
		`;

		super.render();

	}

	/**
	* setValue
	*
	* @param {string} value - the value that you want to set
	*/

	setValue(value){
		$('.js-inspector__textinput__value', this.$el).val(value);
	}
}
module.exports = InspectorReadOnly;